<template>
	<sf-data-table
		ref="grpTable"
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
		:span-method="spanMethod"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcQrty/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.pcQrtyList;
		},
		cols() {
			return this.dayCols_;
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			
			if (columnIndex === 0) {
				let spanSum = 0;
				// console.log('cpnyCd>>>>', this.rows);
				var spanIndex = this.rows.map(r=>r.cpnyCd).indexOf('Total');
				// console.log('index', spanIndex);
				for (let index = 0; index < this.rows.length; index++) {
					const rowObj = this.rows[index];
					if (rowObj.cpnyCd === 'Total') {
						spanSum ++;
					}
				}

				if (rowIndex === spanIndex) {
					return {
						rowspan: spanSum,
						colspan: 1
					};
				} else if (rowIndex <= spanIndex + spanSum && rowIndex > spanIndex) {
					return {
						rowspan: 0,
						colspan: 0
					};
				} else {
					return {
						rowspan: 1,
						colspan: 1
					};
				}
			}
		}
	}
};
</script>

<style></style>
